export default __webpack_public_path__ + "static/media/adam.349214b7.gif";